import { Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { NgForm, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FuseCreateTaskService } from './create-task.service';
import { forkJoin } from 'rxjs';
import moment from 'moment';
import { Router } from '@angular/router';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Inject } from '@angular/core';


@Component({
  selector: 'fuse-create-task',
  templateUrl: './create-task.component.html',
  styleUrls: ['./create-task.component.scss']
})
export class FuseCreateTaskComponent implements OnInit {
    onComplete = new EventEmitter<any>();
    @ViewChild('createTaskNgForm') createTaskNgForm: NgForm;
    createTaskForm: UntypedFormGroup;

    userList: any[] = []
    teamList: any[] = []

    showUserSelection = false;
    showTeamSelection = false;

    searchValue: any = ''

    constructor(
        private _formBuilder: UntypedFormBuilder,
        private dialog: MatDialog,
        private fuseCreateTaskService: FuseCreateTaskService,
        private router: Router,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {}


    ngOnInit() {
        this.load();
        this.showUserSelection = true;
        this.createTaskForm = this._formBuilder.group({
            title: ['', Validators.required],
            description: ['', Validators.required],
            assignedToType: ['user', Validators.required],
            assignedTo: ['', Validators.required],
            priority: [0, Validators.required],
            status: ['opened', Validators.required],
            dueDate: [null, Validators.required],
            taskCategory: [this.data.taskCategory],
            taskSubjectId: [this.data.id]
        });
    }

    load(){
        forkJoin(
            this.fuseCreateTaskService.getAllUsers(),
            this.fuseCreateTaskService.getAllTeams()
            )
            .subscribe((success: any) => {
                this.userList = success[0].users;
                this.teamList = success[1].teams;
            });
    }

    onAssignToChange(event: MatSelectChange) {
        const value = event.value;
        if (value === 'user') {
        this.showUserSelection = true;
        this.showTeamSelection = false;
        } else if (value === 'team') {
        this.showUserSelection = false;
        this.showTeamSelection = true;
        }
    }

        /**
     * Set the task priority
     *
     * @param priority
     */
    setTaskPriority(priority): void
    {
        // Set the value
        this.createTaskForm.get('priority').setValue(priority);
    }

    /**
     * Check if the task is overdue or not
    */
    isOverdue(): boolean
    {
        return moment(this.createTaskForm.get('dueDate').value, moment.ISO_8601).isBefore(moment(), 'days');
    }


    onSubmit() {
        // do something with the form values
        let payload = this.createTaskForm.value;
        if(this.createTaskForm.value.taskCategory === 'Customer Contact'){
            payload.customerContact =  this.data.contact
        }
        this.fuseCreateTaskService.addTask(payload)
        .subscribe((response) => {
            this.onComplete.emit(response);
            this.dialog.closeAll();
        })
    }
}
